var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHtlWiFiOutlined = function SvgHtlWiFiOutlined(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M7.5 12.496a.5.5 0 1 1 1 0 .5.5 0 0 1-1 0Zm-1.991-2.045a.5.5 0 0 1 .118-.7 4.1 4.1 0 0 1 4.75 0 .5.5 0 1 1-.58.818 3.1 3.1 0 0 0-3.592 0 .5.5 0 0 1-.696-.113v-.005Zm6.418-2.042a6.1 6.1 0 0 0-7.809 0 .5.5 0 0 1-.7-.064.5.5 0 0 1 .064-.7 7.1 7.1 0 0 1 9.09 0 .5.5 0 0 1-.108.833.5.5 0 0 1-.212.047.5.5 0 0 1-.325-.112v-.004Zm2.09-2.139a9.117 9.117 0 0 0-12.036 0 .5.5 0 0 1-.662-.751 10.1 10.1 0 0 1 13.36 0 .501.501 0 0 1-.662.755V6.27Z"
  })));
};
export default SvgHtlWiFiOutlined;